import { useQuery } from "@apollo/client/react";
import { IResourceData, resourceType } from "../context/model";
import { RESOURCETYPE_RECORD_CAMPAIGN_QUERY } from "../services/query";
import { useEffect, useState, useCallback, useMemo } from "react";
import { useAppContext } from "../provider/AppContextProvider";

export const useFetchResourceType = (resourceTypeId: string) => {
  const { updateLoading, isInitializing } = useAppContext();
  const [resourceTypeRecord, setResourceTypeRecord] = useState<resourceType[]>(
    []
  );

  const normalizedResourceTypeIds = useMemo(
    () =>
      resourceTypeId
        .split(",")
        .map((id) => id.trim())
        .filter(Boolean),
    [resourceTypeId]
  );

  const { data: dataResourceData, loading: loadingResourceData } =
    useQuery<IResourceData>(RESOURCETYPE_RECORD_CAMPAIGN_QUERY, {
      skip: isInitializing || normalizedResourceTypeIds.length === 0,
      variables: { resourceTypeIds: normalizedResourceTypeIds },
    });

  const fetchData = useCallback(async () => {
    try {
      if (dataResourceData && dataResourceData.cAResourceTypeCollection) {
        const mappedResources: resourceType[] =
          dataResourceData.cAResourceTypeCollection.items.map((resource) => ({
            _system: resource._system,
            title: resource.title,
            imageContentHub: resource.imageContentHub || null,
          }));
        setResourceTypeRecord(mappedResources);
      }
    } catch (error) {
      console.info("Error fetching data:", error);
    }
  }, [dataResourceData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    updateLoading(loadingResourceData, `CampaingResourceTypeLoading${resourceTypeId}`);
  }, [loadingResourceData, updateLoading, resourceTypeId]);

  return { resourceTypeRecord };
};
